export const STATICPAGELOADER = 'STATICPAGELOADER'
